module.exports = require("core-js-pure/features/object/get-own-property-descriptor");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js/object/get-own-property-descriptor.js
// module id = 488
// module chunks = 13